import { TimeTrackingEntryResource } from 'dy-frontend-http-repository/lib/modules/TimeTacking/resources';
import { createApi } from 'effector';
import moment from 'moment';

import { $workReports } from './states';

// API to manage time tracking entries state locally
export const timeTrackingEntriesApi = createApi($workReports, {
    add: (store, payload: TimeTrackingEntryResource) => {
        if (!store) {
            // Task was NOT fetched yet
            return store;
        }

        return { ...store, items: [payload, ...store.items] };
    },

    archive: (store, entryId: ID) => {
        if (!store) {
            return store;
        }

        // Copy items
        const itemsCopy = store.items.slice(0);

        // Find item
        const foundItem = itemsCopy.find((entry) => entry.id === entryId);

        if (!foundItem) {
            return store;
        }

        // Update item archive date
        foundItem.archived_at = moment().utc().format();

        return { ...store, items: itemsCopy };
    },

    restore: (store, entryId: ID) => {
        if (!store) {
            return store;
        }

        // Copy items
        const itemsCopy = store.items.slice(0);

        // Find item
        const foundItem = itemsCopy.find((entry) => entry.id === entryId);

        if (!foundItem) {
            return store;
        }

        // Update item archive date
        foundItem.archived_at = null;

        return { ...store, items: itemsCopy };
    },
});
